












import { Component, Prop, Vue } from "vue-property-decorator";

const LISTA = [
  "Pessoas que desejam viver em plenitude, oferecendo todo o potencial da sua vida para melhorar o mundo, mas ainda não sabem o caminho a percorrer",
  "Homens e mulheres que têm dificuldade em utilizar todo o seu potencial para transformar a própria vida, seja no trabalho, no convívio com outras pessoas ou diante de responsabilidades intelectuais",
  "Homens e mulheres que não conseguem dominar as interações com seu parceiro(a), dificultando seu relacionamento amoroso",
  "Pessoas que estão buscando se autoconhecer, expandir sua consciência e evoluir",
  "Para quem não conhece o que veio fazer nesse mundo e, conseqüentemente, não está feliz com a atual situação que vive",
  "Mães e pais que estão tentando melhorar os vínculos afetivos com suas crianças e adolescentes.",
  "Empresários e empreendedores que querem potencializar seu negócio mas não encontram funcionários capacitados para determinadas áreas",
  "Coaches, psicológos e terapeutas que estão em busca de uma alternativa para entender melhor seus pacientes",
  "Pais que estão tendo dificuldade com seus filhos após o período de separação conjugal",
  "Pessoas que não se sentem valorizadas e amadas por outras que estão à sua volta",
  "Mães e pais que sofrem em relacionamentos conturbados com o(s) filho(s) e estão tentando melhorar os vínculos afetivos, sejam eles crianças após a fase alfabetização ou adolescentes",
  "Qualquer pessoa que desconhece o seu propósito de vida nesse mundo e se sente frustrada ou percebe que sua vida não tem sentido e está sem direcionamento."
];

@Component
export default class extends Vue {
  // @Prop() private msg!: string;
  itens: Array<Item> = [];

  // Lifecycle hook
  mounted() {
    let counter = 0;
    this.itens = LISTA.map(function(item) {
      counter++;
      return new Item(counter, item);
    });
  }
}

class Item {
  numero: number;
  nome: string;
  constructor(numero: number, nome: string) {
    this.numero = numero;
    this.nome = nome;
  }
}
